import React from "react";
import cc from "currency-codes";
import Swal from "sweetalert2";

import { removeResellerRates } from "../../../libs/functions";

import RatesTable from "./RatesTable";

class GatewayRates extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	getRateCurrencies = (rates) => {
		if (rates) {
			return Object.keys(rates)
				.map((i) => cc.number(i).code)
				.sort((a, b) => {
					if (a === "SGD") return -1;
					else if (b === "SGD") return 1;
					else return 0;
				});
		} else return [];
	};

	removeRates = (reseller, paymentGateway, currency) => {
		Swal.fire({
			title: "Removing rates",
			onBeforeOpen: () => {
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const { status } = await removeResellerRates({
						reseller,
						paymentGateway,
						currency: cc.code(currency).number,
					});
					if (status === "success") {
						Swal.fire({
							icon: "success",
							title: "Rates removed!",
						}).then(async () => {
							await this.props.refreshRates();
						});
					}
				} catch (err) {
					Swal.fire({
						icon: "error",
						title: `Unable to remove rates`,
						onClose: () => {},
					});
				}
			},
		});
	};

	render() {
		const {
			reseller,
			gateway,
			rates,
			MDRTypes,
			openEditRates,
			openScheduleRateUpdate,
		} = this.props;

		return (
			<li>
				<ul uk-tab={`connect: #rates-${gateway}-table`}>
					{this.getRateCurrencies(rates).map((currency) => (
						<li key={`rates-${gateway}-${currency}`}>
							<a>
								{currency}
								<button
									className="uk-margin-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
									type="button"
									onClick={() =>
										openEditRates(gateway, cc.code(currency).number)
									}
								/>
								<button
									className="uk-margin-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-clock; ratio: 0.5"
									type="button"
									onClick={() =>
										openScheduleRateUpdate(gateway, cc.code(currency).number)
									}
								/>
								<button
									className="uk-margin-left uk-icon-button uk-button-danger"
									uk-icon="icon: fa-solid-trash; ratio: 0.5"
									type="button"
									onClick={() => this.removeRates(reseller, gateway, currency)}
								/>
							</a>
						</li>
					))}
				</ul>
				<ul id={`rates-${gateway}-table`} className="uk-switcher">
					{this.getRateCurrencies(rates).map((currency) => (
						<RatesTable
							key={`${gateway}-${currency}`}
							currencyRates={rates[cc.code(currency).number]}
							MDRTypes={MDRTypes}
							prefix={`${gateway}-${currency}`}
							isList={true}
						/>
					))}
				</ul>
			</li>
		);
	}
}

export default GatewayRates;
